import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function postMembership(data) {
  const r = await apiClient.post("/membership/apply", data);
  return r.data;
}

export async function postOpportunity(data) {
  const r = await apiClient.post("/opportunities/submit", data);
  return r.data;
}

export async function postContact(data) {
  const r = await apiClient.post("/contact", data);
  return r.data;
}

export async function postCollaboration(data) {
  const r = await apiClient.post("/collaborate/inquire", data);
  return r.data;
}

export async function fetchResources({ category, q } = {}) {
  const params = {};
  if (category && category !== "all") params.category = category;
  if (q) params.q = q;
  const r = await apiClient.get("/knowledge-hub/resources", { params });
  return r.data;
}
